import { isValidDate } from '../../../Helpers/date';

// valida se combinação dia/mês existe
export default function validaData(val) {
  if (!val) return null
  let [d,m,a] = val.split("/")
  if (isValidDate(d,m,a)) {
    return null
  }
  return "Data inválida"
}

// usa a validação padrão 'validaData', confere se ano foi preenchido
// e se está entre 1900 e o ano vigente
export function validaDataNascimento(val) {
  if (!val) return null
  let step1 = validaData(val)
  if (step1) return step1
  let [ d,m,a ] = val.split("/")
  a = parseInt(a)
  if (!a) return "Data inválida"
  if (a < 1900) return "Data inválida"
  if (a > new Date().getFullYear()) return "Data inválida"
}
